import type { ColumnDef } from "@tanstack/react-table";
import type {
  ApprovalLevelRow,
  ApprovalLevelKind,
} from "../types/ApprovalLevel";

const titleize = (s: string | null | undefined) =>
  s ? s.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()) : "";

const KIND_LABEL: Record<ApprovalLevelKind, string> = {
  technical: "Technical",
  sales: "Sales",
  business: "Business",
};

export const approvalLevelColumns: ColumnDef<ApprovalLevelRow>[] = [
  { accessorKey: "name", header: "Name" },
  {
    id: "kind",
    header: "Kind",
    cell: ({ row }) => {
      const kind = row.original.kind;
      return (
        <span className={`approvalKindPill approvalKindPill--${kind}`}>
          {KIND_LABEL[kind] ?? titleize(kind)}
        </span>
      );
    },
  },
  {
    accessorKey: "signaturesRequired",
    header: "# Approvals",
  },
  {
    id: "triggers",
    header: "Trigger",
    cell: ({ row }) => row.original.triggerDescription || "—",
  },
  {
    accessorKey: "submitterMayApprove",
    header: "Submitter Approves?",
    cell: ({ getValue }) => (getValue() ? "Yes" : "No"),
  },
  {
    accessorKey: "limitApprovalsToTeam",
    header: "Team Approval?",
    cell: ({ getValue }) => (getValue() ? "Yes" : "No"),
  },
];
